import React, { useState, useEffect } from 'react';

//Components
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import TabelaListagemFichas from '../../../components/TabelaListagemFichas/TabelaListagemFichas';


export default function TabelaQuestao({ items = [], actions = [], ficha }) {
    items.sort((a, b) => {
        // Ordenando as questões na tabela pela sequência
        return parseInt(a.sequencia) - parseInt(b.sequencia);
    });

    //Estado de controle dos items
    const [questoes, setQuestoes] = useState([...items]);

    //Cabeçalhos da tabela de questões
    const headersQuestoes = [
        { value: "Sequência", objectValue: "sequencia" },
        { value: "Identificação", objectValue: "identificacao" },
        { value: "Tipo de valor", objectValue: "tipoValor" },
        { value: "Campo obrigatório", objectValue: "obrigatorio" },
        { value: "Possui dependência", objectValue: "possuiDependencia" },
        { value: "Tipo de Fotografia", objectValue: "tipoFotografia"}
    ]

    useEffect(() => {
        const _questoes = items.map(value => {
            const _value = { ...value };
            _value.obrigatorio = _value.obrigatorio ? "Sim" : "Não";
            _value.possuiDependencia = _value.possuiDependencia ? "Sim" : "Não";
            return _value;
        });
        setQuestoes(_questoes);
    }, [items]);
    if (ficha)
        return <TabelaListagemFichas headers={headersQuestoes} items={questoes} />

    return (
        <TabelaListagem actions={actions} headers={headersQuestoes} items={questoes} />
    )
}